var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8823 8.03291C10.8823 6.99696 10.0429 6.15753 9.00694 6.15753C7.97175 6.15753 7.13232 6.99696 7.13232 8.03291C7.13232 9.0681 7.97175 9.90753 9.00694 9.90753C10.0429 9.90753 10.8823 9.0681 10.8823 8.03291Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99963 15.75C6.82611 15.75 3.375 11.969 3.375 7.94898C3.375 4.80185 5.89283 2.25 8.99963 2.25C12.1064 2.25 14.625 4.80185 14.625 7.94898C14.625 11.969 11.1739 15.75 8.99963 15.75Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.c800ce9e5192a0d3ed0fcab9fc09afb6.svg";
export { ForwardRef as ReactComponent };